import moment from 'moment'

export const validateDateOfBirth = (dateOfBirth: any) => {
  const regex = /^(0?[1-9]|[12][0-9]|3[01])\/(0?[1-9]|1[0-2])\/\d{4}$/
  if (!regex.test(dateOfBirth)) return false

  const [day, month, year] = dateOfBirth.split('/')
  if (parseInt(day, 10) > 31 || parseInt(month, 10) > 12) return false

  return true
}

export const convertDate = (date?: any) => {
  if (date) {
    let dateParts = date.split('/')
    let formattedDate = `${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`
    return formattedDate
  }
}

export const validateInput = (input?: any) => {
  const regex = /^\S.*\S$/
  return regex.test(input)
}

export const validateInputConctAddr = (input?: any) => {
  const regex = /^\S.{25,}\S$/

  return regex.test(input)
}

export const getAge = (dateString?: any) => {
  if (dateString) {
    const dateMoment = moment(dateString, 'DD/MM/YYYY')
    const today = new Date()
    const birthDate = dateMoment.toDate()
    let age = today.getFullYear() - birthDate.getFullYear()
    const m = today.getMonth() - birthDate.getMonth()
    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--
    }
    return age
  }
  return 0
}
